import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import {
  DxMenuModule,
  DxTextBoxModule,
  DxValidatorModule,
  DxButtonModule,
  DxLoadPanelModule,
  DxDropDownBoxModule,
  DxDataGridModule,
  DxPopupModule,
  DxCheckBoxModule,
  DxDateBoxModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTooltipModule,
  DxFileUploaderModule,
  DxSchedulerModule,
  DxFormModule,
  DxValidationSummaryModule,
  DxTagBoxModule,
  DxFilterBuilderModule,
  DxTreeListModule,
  DxSwitchModule,
  DxNumberBoxModule,
  DxTabPanelModule,
  DxRadioGroupModule,
  DxAccordionModule,
  DxLoadIndicatorModule,
  DxScrollViewModule,
  DxTreeViewModule,
  DxCalendarModule,
  DxGalleryModule,
  DxPieChartModule,
  DxChartModule
} from 'devextreme-angular';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    FormsModule,
    DxMenuModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxDropDownBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxCheckBoxModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTooltipModule,
    DxFileUploaderModule,
    DxSchedulerModule,
    DxFormModule,
    DxValidationSummaryModule,
    DxTagBoxModule,
    DxFilterBuilderModule,
    DxTreeListModule,
    DxSwitchModule,
    DxNumberBoxModule,
    DxTabPanelModule,
    DxRadioGroupModule,
    DxAccordionModule,
    DxLoadIndicatorModule,
    DxScrollViewModule,
    DxTreeViewModule,
    DxCalendarModule,
    DxGalleryModule,
    DxPieChartModule,
    DxChartModule
  ],
})
export class DevExtremeModule {}
